var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10,9.6c-2,0-3.5-1.6-3.5-3.5s1.6-3.6,3.5-3.6,3.5,1.6,3.5,3.5-1.6,3.6-3.5,3.6ZM10,3.5c-1.4,0-2.5,1.1-2.5,2.5s1.1,2.6,2.5,2.6,2.5-1.1,2.5-2.5-1.1-2.6-2.5-2.6Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1,17.5H3.9c-.3,0-.5-.2-.5-.5v-4.7c0-2,2-3.2,2.2-3.3.2-.2.5,0,.7.2.9,1.1,2.3,1.8,3.8,1.8s2.9-.7,3.9-1.8c0,0,.2-.2.4-.2.2,0,.2,0,.3,0,.2.2,2.1,1.4,2.1,3.3v4.7c0,.3-.2.5-.5.5ZM4.4,16.5h11.2v-4.2c0-1-.8-1.8-1.3-2.2-1.1,1.2-2.6,1.8-4.3,1.8s-3.2-.7-4.3-1.8c-.5.4-1.3,1.1-1.3,2.2,0,0,0,4.2,0,4.2Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.d77127df5cefcc152f39f64e90e25826.svg";
export { ForwardRef as ReactComponent };